import type { FaireProductEntity } from "../../entity_types/product";

export const p_qk7q9en6h4: FaireProductEntity = {
  token: "p_qk7q9en6h4",
  type: "product",
  name: "OkLoveYouBye Sticker",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/f7e0f0963de1c75cd64b2c8709c8bb95e26c27654507dbd2ecbbd193c58c880d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/002f90218c313f72c6f66985336c4bc2a07cae579fa6e549b235aa850106614f.jpeg",
    "https://cdn.faire.com/fastly/5e39d25b578147df05d25555e8e552902db5c8f2d6a2f73aa71e78a3f097aae4.png",
  ],
  priceDollars: 2.5,
  description:
    "Water-resistant, Die-cut Stickers with crack and peel backing. Have fun decorating those laptops and water bottles!",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:15.093Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
